<div class="bz-env-component">
  <biz-column-encryption-key></biz-column-encryption-key>
  <biz-encryption-entity-logs></biz-encryption-entity-logs>
</div>